import * as React from "react";
import Timer from "consent/utils/timer";
import {handleConsentNavigation} from "consent/route";
import {setRoute} from "consent";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {ILoanApprovalInfo} from "StateInterface";
import {RouteComponentProps} from "react-router-dom";
import {getLatestLoanOpp} from "consent/actions";
import {useEffect} from "react";
import {AndroidApis} from "app";
import {ConsentBox} from "consent/utils/consentBox";

type FinalProps = IConnectProps & RouteComponentProps;

interface IConnectProps {
    loanApprovalInfo: ILoanApprovalInfo;
    unsignedDocBase64Str: string;
    userId: number;
    loading: boolean;
    isAndroid: boolean;
    isPartnerAndroid: boolean;
    dispatch?: (action: any) => void;
    utm_source?: string;
    lenderOpportunityId: string;
}

export const Redirection = (props: FinalProps) => {
    useEffect(() => {
        if (props.isAndroid && !props.isPartnerAndroid) {
            AndroidApis.clearWebStack();
        }
    });
    return (
        <ConsentBox>
            <div className="flex-column-center-row" style={{marginTop: 86}}>
                <Timer duration={10}
                       onFinish={() => {
                           props.dispatch(getLatestLoanOpp(props.lenderOpportunityId));
                           const timer = setInterval(() => {
                               if (!props.loading) {
                                   clearInterval(timer);
                                   handleConsentNavigation(setRoute(props.loanApprovalInfo, props.unsignedDocBase64Str, props.location, false));
                               }
                           }, 500);
                       }}
                       text="We are processing"
                       utmSource={props.utm_source}
                />
            </div>
        </ConsentBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        loanApprovalInfo: state.consent.loanApprovalInfo,
        lenderOpportunityId: state.consent.lenderOpportunityId,
        unsignedDocBase64Str: state.consent.unsignedDocBase64Str,
        userId: state.login.auth.userId,
        loading: state.userform.loading,
        isAndroid: state.login.isAndroid,
        isPartnerAndroid: state.login.isPartnerAndroid,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(Redirection);
